"use client";

import type { ReactNode } from "react";
import { useReducedMotion } from "@/hooks/use-reduced-motion";

interface FadeUpSectionProps {
  /** Cascade delay in milliseconds. */
  delay: number;
  children: ReactNode;
}

/**
 * Light wrapper that applies a "fade + translate up" entrance to its
 * children, with a per-section delay for cascading. Falls back to a
 * plain wrapper when the user has `prefers-reduced-motion: reduce`.
 *
 * The keyframe (`piece-overview-fadeup`) is injected once at the top
 * of `PieceOverviewOverlay` so multiple wrappers don't re-emit it.
 */
export function FadeUpSection({ delay, children }: FadeUpSectionProps) {
  const reduced = useReducedMotion();

  if (reduced) {
    return <div>{children}</div>;
  }

  return (
    <div
      style={{
        animation: `piece-overview-fadeup 400ms ${delay}ms ease both`,
      }}
    >
      {children}
    </div>
  );
}
